
















































import Component from "vue-class-component";
import Pagination from "@/common-class/pagination";
import OrderItem from "./orderItem.vue";
import moduleStore from "../store/index";
import Radio from "./radio.vue";
import { Toast } from "vant";
import moment from "moment";
import NoData from "./noData.vue"
@Component({
  props: {
    currentDate: {
      type: Date,
      default: new Date(),
    }
  },
  components: { OrderItem, Radio,NoData },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Pagination {
  orderList: any[] = [];
  isSelect = false;
  isPageSelect = false;
  selectList = [];
  startTime;
  toastLoading:any = false
  queryMonth = this.$props.currentDate.format("yyyy-MM")
  scrollTop = 0;
  created() {}
  mounted() {
    this.getStartTime();
    if(this.$refs.list){
      const artListDom: any = (this.$refs.list as any).$el;
      // 当其滚动时，记录滚动后的top位置
      artListDom.addEventListener("scroll", () => {
        this.scrollTop = artListDom.scrollTop;
      });
    }
    this.onRefresh()

  }
  activated() {
    if(this.$refs.list){
      // 该路由组件激活时，记录滚动位置
      (this.$refs.list as any).$el.scrollTop = this.scrollTop;
    }
  }
  async getStartTime() {
    const res = await this.$http("invoiceStart", {});
    if (res.code == 200) this.startTime = res.data;
  }
  async getList() {
    try {
      this.queryMonth = this.$props.currentDate.format("yyyy-MM")
      this.toastLoading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 2000,
      })
      const res = await (this as any).getOrderList({
        page: this.currentPage,
        size: this.pageSize,
        type: "WAIT",
        queryMonth:this.queryMonth

        // WAIT :可开票
        // FINISH :已开票
        // OTHER :其他
      });
      this.toastLoading.clear()
      if (this.refreshing) {
          this.orderList = [];
      }
      if (res.code == 200) {
        this.orderList.push(...res.data.results);
        this.totalPage = res.data.total_pages;
      }
      this.refreshing = false;
      this.loading = false;
      if (res.code != 200) this.error = true;
    } catch (err) {
      this.refreshing = false;
      this.loading = false;
      this.error = true;
    }
  }
  onRefresh() {
    // 下拉刷新
    this.orderList = [];
    this.refresh(() => {
      this.getList();
    });
  }
  onLoad() {
    // 上拉滚动加载
    console.log("加载");
    this.loadMore(() => {
      this.getList();
    });
  }
  infoAll: any = { num: 0, money: 0.0 };
  get info() {
    if (this.isSelect) return this.infoAll;
    const money =
      this.selectList.length > 0 && this.orderList.length>0
        ? this.orderList
            .filter((vo) => this.selectList.includes(vo.id))
            .map((vo) => vo.amount)
            .reduce((prev, curr, idx, arr) => {
              return prev + curr;
            })
        : 0;
    this.pageState.totalMoney = money;
    return {
      num: this.selectList.length,
      money: (money / 100).toFixed(2),
    };
  }
  itemIsSelect(item) {
    return this.isSelect
      ? (moment(this.startTime).format("YYYY-MM-DD HH:mm:ss") <
          moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss") && item.id)
      : this.selectList.includes(item.id);
  }
  selectItem(item) {
    let isTT = localStorage.getItem('platform') == 'tt';
    if(!item.id){
      Toast('该订单存在异常，请联系客服！')
      return
    }
    const index = this.selectList.indexOf(item.id);
    if (index == -1) {
      if (
        moment(this.startTime).format("YYYY-MM-DD HH:mm:ss") >
        moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
      ) {
        let message = '仅支持联系客服申请发票，联系客服路径：【我的-会员服务-客服微信号】';
        if(isTT){
          message = '不支持';
        }
        Toast(
          `${moment(this.startTime).format(
            "YYYY-MM-DD"
          )}日之前的发票${message}`
        );
        return;
      }
      this.selectList.push(item.id);
    } else {
      this.selectList.splice(index, 1);
    }
  }
  async selectAll() {
    this.isSelect = !this.isSelect;
    if (this.isPageSelect) this.isPageSelect = false;
    if (this.isSelect) {
      const res = await (this as any).getNumMoney();
      this.infoAll = {
        num: res.data.count || 0,
        money: (res.data.amount / 100).toFixed(2),
      };
      this.pageState.totalMoney = res.data.amount;
    } else {
      this.selectList = [];
    }
  }
  selectPageAll() {
    this.isPageSelect = !this.isPageSelect;
    if (this.isSelect) this.isSelect = false;
    this.selectList = this.isPageSelect
      ? this.orderList
          .filter(
            (vo) =>
              moment(this.startTime).format("YYYY-MM-DD HH:mm:ss") <
              moment(vo.createdAt).format("YYYY-MM-DD HH:mm:ss") && vo.id
          )
          .map((vo) => vo.id)
      : [];
  }
  goInvoice() {
    if (this.info.num==0) {
      Toast("请选择订单！");
      return;
    }
    this.pageState.orderIds = this.selectList;
    this.pageState.isAll = this.isSelect;
    this.$router.push({
      path: "/order/invoicing",
      query: {
        isAll: this.isSelect ? "1" : "0",
        ids: this.selectList.join(","),
      },
    });
  }
}
